/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import { DEFAULT_CURRENCY } from '../locales';
import * as Permission from '../util/Permission';

export default declareLinkedEntity({
    entity: "flowDefDocs",
    graphQL: "FlowDefDoc",
    name: "Flow Definition documentation",
    writePermission: [
        Permission.PERM_EDIT_CHANNEL_DEF
    ],
    parentRelation: "flowDefDocs",
    defaultTitle: (data) => {
        return data['name'];
    },
    isPublic: true,
    dynamoPrefix: 'def',
    storageType: 'schema',
    onModify: ['flowDef'],
    defaultOrder: ['channelDef1_id', 'channelDef2_id'],
    fields: (types) => { return {
        id: {
            name: "Flow Definition Documentation ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
            compositeKey: true,
        },
        flowDef: {
            name: "Flow Definition",
            to: () => types['flowDefs'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
            compositeKey: true,
            relativeTo: ["flowDefVersion"],
        },
        flowDefVersion: {
            name: "Flow Definition Version",
            to: () => types['flowDefVersions'],
            type: "relation",
            defaultValue: (flow) => {
                return flow['flowDefVersion_id'];
            },
            required: true,
            hiddenCreate: true,
            compositeKey: true,
        },
        channelDef1: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
        },
        channelDef2: {
            name: "Application Definition",
            to: () => types['channelDefs'],
            type: "relation",
        },
        tutorialLink: {
            name: "Tutorial Link",
            type: "url",
            isPublic: true,
            defaultValue: ""
        },
        documentationLink: {
            name: "Documentation Link",
            type: "url",
            isPublic: true,
            defaultValue: ""
        },
        techDocumentationLink: {
            name: "Technical Documentation Link",
            type: "url",
            isPublic: true,
            defaultValue: ""
        },
        connectionType: {
            name: "Connection Type",
            type: "enum",
            defaultValue: "",
            values: {
                "api": {
                    "name": "API"
                },
                "csv-email": {
                    "name": "CSV in e-mail"
                },
                "xml-email": {
                    "name": "XML in e-mail"
                },
                "xls-email": {
                    "name": "XLS in e-mail"
                },
                "xlsx-email": {
                    "name": "XLSX in e-mail"
                },
                "mt940-email": {
                    "name": "MT940 in e-mail"
                },
                "manual-csv-email": {
                    "name": "Manual e-mail with CSV"
                },
                "manual-txt-email": {
                    "name": "Manual e-mail with TXT"
                },
                "manual-xls-email": {
                    "name": "Manual e-mail with XLS"
                },
                "manual-xlsx-email": {
                    "name": "Manual e-mail with XLSX"
                },

            },
        },
        transferFrequency: {
            name: "Transfer Frequency",
            type: "enum",
            defaultValue: "",
            values: {
                "custom": {
                    "name": "By settings"
                },
                "hourly": {
                    "name": "Every hour"
                },
                "hourly2": {
                    "name": "Every hour*"
                },
                "any": {
                    "name": "Any"
                },
            },
        },
        fees: {
            name: "Fees",
            type: "boolean",
        },
        author: {
            name: "Author",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; },
    relations: (types) => { return {
        flowStepLinkDefs: {
            type: 'oneToMany',
            to: types['flowStepLinkDefs'],
            export: true,
            defaultValue: () => {
                return {};
            },
        },
    }; }
});
